import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLicense } from '@syncfusion/ej2-base';
import { ETHICO_MYCM_CONFIG_KEY } from './app/app.constants';
import { debugLog } from './app/core/utils/debug-logger';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXtfdXRcR2hcWE1wV0ZWZ0g=');

// Capture the MyCM postMessage BEFORE Angular bootstraps to avoid the race condition
// where MyCM sends the config token before the app listener is registered.
// The captured event is stashed on window so MyCMIntegrationService can replay it
// synchronously during APP_INITIALIZER (before routing starts).
declare global { interface Window { __earlyMyCMEvent?: MessageEvent; } }
const earlyMessageHandler = (event: MessageEvent) => {
  const hasConfigPayload = !!event?.data?.payload && typeof event.data.payload === 'object';
  const hasTopLevelToken = !!(event?.data?.token || event?.data?.jwtToken);
  if (hasConfigPayload || hasTopLevelToken) {
    debugLog('EP Main', 'early message captured', {
      origin: event.origin,
      type: event?.data?.type,
      hasToken: !!(event?.data?.token || event?.data?.jwtToken || event?.data?.payload?.token),
      href: globalThis.location.href,
    });
    window.__earlyMyCMEvent = event; //nosonar  
    window.removeEventListener('message', earlyMessageHandler);
  }
};
if (globalThis.self !== globalThis.top) {
  globalThis.addEventListener('message', earlyMessageHandler);
  // Send the ready signal immediately (before Angular bootstraps) so MyCM starts
  // sending the config token as early as possible. The response is captured above
  // and processed by MyCMIntegrationService.initializeMessageListener() after env loads.
  // Use the parent-page origin from document.referrer when available (more secure);
  // fall back to the parent window's own location origin.
  let earlyTargetOrigin: string;
  try {
    earlyTargetOrigin = document.referrer
      ? new URL(document.referrer).origin
      : window.parent.location.origin;
  } catch {
    // Cross-origin access to parent.location throws; infer from referrer instead.
    earlyTargetOrigin = document.referrer ? new URL(document.referrer).origin : '*';
  }
  debugLog('EP Main', 'sending early ready signal', {
    targetOrigin: earlyTargetOrigin,
    referrer: document.referrer,
    href: globalThis.location.href,
  });
  window.parent.postMessage(
    { type: ETHICO_MYCM_CONFIG_KEY, payload: `${ETHICO_MYCM_CONFIG_KEY}-ready` },
    earlyTargetOrigin,
  );
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err)); // NOSONAR
